import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from 'axios';
// import axios from '../../utils/axios';
import i18n from 'i18next';

let setlang = i18n.language;
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  posts: [],
  post: null,
  recentPosts: [],
  hasMore: true,
  index: 0,
  step: 11
};

const slice = createSlice({
  name: 'blog',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET POSTS
    getPostsSuccess(state, action) {
      state.isLoading = false;
      state.posts = action.payload;
    },

    // GET POST INFINITE
    getPostsInitial(state, action) {
      state.isLoading = false;
      state.posts = action.payload;
    },

    getMorePosts(state) {
      const setIndex = state.index + state.step;
      state.index = setIndex;
    },

    noHasMore(state) {
      state.hasMore = false;
    },

    // GET POST
    getPostSuccess(state, action) {
      state.isLoading = false;
      state.post = action.payload;
    },

    // GET RECENT POST
    getRecentPostsSuccess(state, action) {
      state.isLoading = false;
      state.recentPosts = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { getMorePosts } = slice.actions;

// ----------------------------------------------------------------------

export function getAllPosts() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/blog/posts/all');
      dispatch(slice.actions.getPostsSuccess(response.data.posts));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getPostsInitial(index, step) {
  return async (dispatch, getState) => {
    let posts = getState().blog.posts
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('https://api.asystent.biz/api/'+setlang+'/news', {
        params: { index, step }
      });
      let all = [...posts, ...response.data.list]
      const results = all.length;
      const maxLength = response.data.count;

      dispatch(slice.actions.getPostsInitial(all));
      if (results >= maxLength) {
        dispatch(slice.actions.noHasMore());
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getPost(title) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('https://api.asystent.biz/api/'+setlang+'/news/'+title, {
        params: { title }
      });
      dispatch(slice.actions.getPostSuccess(response.data.item));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError());
    }
  };
}

// ----------------------------------------------------------------------

export function getRecentPosts(title) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let index = 0,
          step = 4;
      const response = await axios.get('https://api.asystent.biz/api/'+setlang+'/news', {
        params: { title, index, step }
      });

      dispatch(slice.actions.getRecentPostsSuccess(response.data.list));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError());
    }
  };
}
